/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: hongye
 * @LastEditTime: 2026-01-29 10:07:15
 */
import request from '../request'
const VITE_APP_I18N_URL = import.meta.env.VITE_APP_I18N_URL
const GET_I18N = VITE_APP_I18N_URL + '/sysInternational/getSysInternationalList'
enum Api {
  QUERY_LIST = '/enum/queryList'
}

export default class dictService {
  /**
   * 获取i18n数据
   * @param data
   * @returns
   */
  static getI18n(data: any): Promise<any> {
    return request.get(GET_I18N, data)
  }
  /**
   * 获取枚举
   * @param data
   * @returns
   */
  static queryList(data: Record<string, any>): Promise<any> {
    return request.post(Api.QUERY_LIST, data)
  }
}
